type Pluralizations = "s" | "ies"
/**
 * Extend function as needed to support more cases...
 * defaults to pluralized version for amount == 0
 */
const pluralize = (textSingular: string, amount: number, postfix: Pluralizations = "s") => {
  let pluralizedText = textSingular;
  
  if (amount !== 1) {
    if (postfix === "ies") {
      pluralizedText = pluralizedText.replace(/y$/i, "ies");
    } else if (postfix === "s") {
      pluralizedText += postfix;
    }
  }

  return pluralizedText;
}

export default pluralize;
